export function getContentType(type) {
    switch (type) {
        case 1: //Enrollment by Age
            return "Enrollment By Age";
        case 2: //Total Premium by Plan Type
            return "Total Premium by Plan Type";
        case 3: //Video
            return "Video";
        case 4: //Text
            return "Text";
        case 5: //Location
            return "Location";
        case 6: //Image
            return "Image";
        case 7: //Table
            return "Table";
        case 8: //Document
            return "Document";
        case 9: //Multimedia
            return "Multimedia";
        case 10: //Child Portal
            return "Child";
        case 11: //Link
            return "Link";
        case 12: //Asset Upload
            return "Asset Upload";
        default:
            return null;
    }
  }
  